var React = require('react');

function SocialIconYoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M151.096 92h.19l.876.002c11.375.029 93.38.438 114.887 6.284 12.855 3.466 22.896 13.474 26.375 26.285 9.842 39.486 7.568 101.848.19 142.858-3.478 12.81-13.52 22.819-26.374 26.285-22.2 6.035-108.866 6.276-115.763 6.286h-.873c-6.898-.01-93.563-.251-115.764-6.286-12.854-3.466-22.896-13.474-26.374-26.285-9.9-39.315-7.186-101.715-.191-142.667 3.478-12.811 13.52-22.82 26.374-26.286 21.97-5.971 107.068-6.442 115.523-6.474l.43-.001h.137zM121 151v89l77-44.5-77-44.5z"}));
}

SocialIconYoutubeInline.defaultProps = {"viewBox":"0 0 300 300"};

module.exports = SocialIconYoutubeInline;

SocialIconYoutubeInline.default = SocialIconYoutubeInline;
